<template>
  <div class="second">
    <div class="custom-nav-bar">黑密秀发AI诊断系统</div>

    <!-- 修改后的进度信息 -->
    <div class="progress-container">
      <div class="progress-info">
        已答: {{ answeredCount }} / 总题数: {{ questionList.length }}
      </div>
    </div>

    <!-- 问卷题 -->
    <div v-for="(item, index) in questionList" :key="item.id">
      <div class="test-content" v-if="index == page">
        <div class="content-title">{{ index + 1 }}.{{ item.question }}</div>

        <!-- 根据题目类型渲染不同的输入组件 -->
        <div v-if="item.type === 'radio'">
          <van-radio-group v-model="radio">
            <van-radio
              class="radio"
              v-for="(answer, i) in getAnswers(item)"
              :key="i"
              :name="answer.num + ',' + item.id + ',' + i"
            >
              {{ answer.text }}
            </van-radio>
          </van-radio-group>
        </div>
        <!-- 您的白发时间 -->
        <div v-if="item.type === 'checkbox' && item.id === 4">
          <van-checkbox-group v-model="selectedFirstPage" :max="2">
            <van-checkbox
            shape="square"
              v-for="(answer, i) in getAnswers(item)"
              :key="i"
              :name="answer.num + ',' + item.id + ',' + i"
            >
              {{ answer.text }}
            </van-checkbox>
          </van-checkbox-group>
        </div>
        <!-- 饮食偏好 -->
        <div v-if="item.type === 'checkbox' && item.id === 18">
          <van-checkbox-group v-model="yinshipianhao18" :max="2">
            <van-checkbox
             shape="square"
              v-for="(answer, i) in getAnswers(item)"
              :key="i"
              :name="answer.num + ',' + item.id + ',' + i"
            >
              {{ answer.text }}
            </van-checkbox>
          </van-checkbox-group>
        </div>
          <!-- 饮食偏好 -->
          <div v-if="item.type === 'checkbox' && item.id === 19">
          <van-checkbox-group v-model="bian19" :max="2">
            <van-checkbox
             shape="square"
              v-for="(answer, i) in getAnswers(item)"
              :key="i"
              :name="answer.num + ',' + item.id + ',' + i"
            >
              {{ answer.text }}
            </van-checkbox>
          </van-checkbox-group>
        </div>
        <div v-if="item.type === 'checkbox' && item.id === 30">
          <van-checkbox-group v-model="selectedConstitutions" :max="2">
            <van-checkbox
            class="checkbox30"
             shape="square"
              v-for="(answer, i) in getAnswers(item)"
              :key="i"
              :name="answer.num + ',' + item.id + ',' + i"
            >
              {{ answer.text }}
            </van-checkbox>
          </van-checkbox-group>
        </div>

        <div class="btn">
          <van-button
            style="margin-top: 30px"
            class="back1"
            @click="toBack(index)"
            v-if="index != 0"
            type="default"
          >
            上一题
          </van-button>

          <van-button
            style="margin-top: 30px; margin-left: auto"
            @click="toNext(index, item.id)"
            v-if="isShow"
            color="#fb7e22"
          >
            下一题
          </van-button>

          <van-button
            style="margin-top: 30px; margin-left: auto"
            class="next"
            v-if="!isShow"
            @click="submit(item)"
            color="#fb7e22"
          >
            提交
          </van-button>
        </div>
      </div>
    </div>

    <!-- 弹窗显示得分 -->
    <van-dialog
      v-model:show="showDialog"
      title="请稍等"
      :showConfirmButton="false"
    >
      <div class="dialog-content">
        <p v-if="isGenerating">智能模型数据生成中...</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "SecondQuestionnaire",
  data() {
    return {
      index30: 30,
      selectedDiet: [], // 存储饮食偏好的选中项 id17
      isGenerating: true, // 控制是否显示“数据生成中”
      page: 0,
      radio: "",
      questionInfos: [],
      selectedFirstPage: [], // 存储第一页的选中项
      yinshipianhao18: [],//18多选
      bian19: [],//19多选
      selectedConstitutions: [], // 存储体质评定的选中项
      isShow: true,
      showDialog: false,
      totalScore: 0,
      hairGradeInfo: "", // 白发等级信息
      questionList: [
        {
          id: 1,
          question: "您的白发时间：",
          type: "radio",
          answer1: "2年内",
          answer1Num: 1,
          answer2: "2-3年",
          answer2Num: 2,
          answer3: "3-5年",
          answer3Num: 3,
          answer4: "5-8年",
          answer4Num: 4,
          answer5: "8年以上",
          answer5Num: 5,
        },
        {
          id: 2,
          question: "您的年龄阶段：",
          type: "radio",
          answer1: "35岁内",
          answer1Num: 1,
          answer2: "36-42岁",
          answer2Num: 2,
          answer3: "43-49岁",
          answer3Num: 3,
          answer4: "50-56岁",
          answer4Num: 4,
          answer5: "57-63岁以上",
          answer5Num: 5,
        },
        {
          id: 3,
          question: "您的白发比例：",
          type: "radio",
          answer1: "15%以内",
          answer1Num: 1,
          answer2: "20%-30%",
          answer2Num: 2,
          answer3: "31%-40%",
          answer3Num: 3,
          answer4: "41%-50%",
          answer4Num: 4,
          answer5: "50%以上",
          answer5Num: 5,
        },
        {
          id: 4,
          question: "白发分布(最多可以选两个)：",
          type: "checkbox",
          answer1: "头顶",
          answer1Num: 3,
          answer2: "前额",
          answer2Num: 4,
          answer3: "两鬓",
          answer3Num: 5,
          answer4: "后脑勺",
          answer4Num: 2,
          answer5: "全头分散",
          answer5Num: 3,
        },
        {
          id: 5,
          question: "头皮油腻:",
          type: "radio",
          answer1: "是",
          answer1Num: 3,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 6,
          question: "是否有头皮屑：",
          type: "radio",
          answer1: "是",
          answer1Num: 3,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 7,
          question: "头皮敏感/瘙痒：",
          type: "radio",
          answer1: "是",
          answer1Num: 3,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 8,
          question: "头皮温度：",
          type: "radio",
          answer1: "36度以下",
          answer1Num: 3,
          answer2: "36.5度以上",
          answer2Num: 2,
          answer3: "36.8度以上",
          answer3Num: 1,
        },
        {
          id: 9,
          question: "头皮油脂含量：",
          type: "radio",
          answer1: "小于0.8mg",
          answer1Num: 4,
          answer2: "0.8-1.2mg",
          answer2Num: 0,
          answer3: "大于1.2mg",
          answer3Num: 4,
        },
        {
          id: 10,
          question: "毛囊密度：",
          type: "radio",
          answer1: "稀疏（<150个/cm2）",
          answer1Num: 3,
          answer2: "正常（180-220个/cm2）",
          answer2Num: 1,
          answer3: "密集（>220个/cm2）",
          answer3Num: 0,
        },
        {
          id: 11,
          question: "毛囊萎缩：",
          type: "radio",
          answer1: "轻度萎缩（15-30%）",
          answer1Num: 3,
          answer2: "中度萎缩（30-50%）",
          answer2Num: 4,
          answer3: "重度萎缩（50%以上）",
          answer3Num: 5,
        },
        {
          id: 12,
          question: "头皮炎症：",
          type: "radio",
          answer1: "是",
          answer1Num: 4,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 13,
          question: "头皮红血丝：",
          type: "radio",
          answer1: "是",
          answer1Num: 4,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 14,
          question: "发质干枯分叉：",
          type: "radio",
          answer1: "否",
          answer1Num: 0,
          answer2: "是",
          answer2Num: 4,
        },
        {
          id: 15,
          question: "头皮PH值：",
          type: "radio",
          answer1: "小于4.5过酸",
          answer1Num: 4,
          answer2: "大于5.5过碱",
          answer2Num: 5, // 唯一值但得分映射为4
          answer3: "4.5-5.5正常",
          answer3Num: 0,
        },
        {
          id: 16,
          question: "黑色素活性：",
          type: "radio",
          answer1: "低50%",
          answer1Num: 5,
          answer2: "中50%-80%",
          answer2Num: 4,
          answer3: "高80%",
          answer3Num: 3,
        },
        {
          id: 17,
          question: "毛囊状态：",
          type: "radio",
          answer1: "健康（直径0.06mm）",
          answer1Num: 0,
          answer2: "正常（直径>0.05mm）",
          answer2Num: 1,
          answer3: "萎缩（直径<0.03mm）",
          answer3Num: 3,
        },
        {
          id: 18,
          question: "饮食偏好(最多可以选两个)：",
          type: "checkbox",
          answer1: "常吃外卖/高油盐",
          answer1Num: 5,
          answer2: "素食为主",
          answer2Num: 3,
          answer3: "蛋白质摄入不足",
          answer3Num: 2,
          answer4: "爱吃甜食",
          answer4Num: 4,
          answer5: "营养均衡",
          answer5Num: 0,
        },
        {
          id: 19,
          question: "生活规律(最多可以选两个)：",
          type: "checkbox",
          answer1: "常熬夜23点后睡",
          answer1Num: 5,
          answer2: "睡眠不足8小时",
          answer2Num: 4,
          answer3: "睡眠质量不佳/易醒",
          answer3Num: 4,
          answer4: "压力大/焦虑",
          answer4Num: 4,
          answer5: "生活规律",
          answer5Num: 0,
        },
        {
          id: 20,
          question: "日均压力值：",
          type: "radio",
          answer1: "1-3分",
          answer1Num: 2,
          answer2: "4-5分",
          answer2Num: 3,
          answer3: "6-7分",
          answer3Num: 4,
          answer4: "8-10分",
          answer4Num: 5,
        },
        {
          id: 21,
          question: "饮食不规律：",
          type: "radio",
          answer1: "否",
          answer1Num: 0,
          answer2: "是",
          answer2Num: 3,
        },
        {
          id: 22,
          question: "每周吃鱼小于2次：",
          type: "radio",
          answer1: "是",
          answer1Num: 3,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 23,
          question: "绿色蔬菜小于200g/天：",
          type: "radio",
          answer1: "是",
          answer1Num: 3,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 24,
          question: "坚果/种子小于1把/天：",
          type: "radio",
          answer1: "是",
          answer1Num: 3,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 25,
          question: "长期服用抑酸药物：",
          type: "radio",
          answer1: "是",
          answer1Num: 3,
          answer2: "否",
          answer2Num: 0,
        },
        {
          id: 26,
          question: "舌诊-形状：",
          type: "radio",
          answer1: "舌头胖大（脾虚，气虚）",
          answer1Num: 4,
          answer2: "舌头细小细长（气血亏虚，阴虚）",
          answer2Num: 4,
          answer3: "舌头肿胀靑瘀（肝气不舒）",
          answer3Num: 4,
          answer4: "舌头两侧凹陷（肝血不足）",
          answer4Num: 4,
          answer5: " 大小适中柔软灵活（平和体质）",
          answer5Num: 0,
        },
        {
          id: 27,
          question: "舌诊-津液：",
          type: "radio",
          answer1: "干（体燥，缺水）",
          answer1Num: 4,
          answer2: "正常（滋润）",
          answer2Num: 0,
          answer3: "多湿（湿气重，寒湿）",
          answer3Num: 4,
        },
        {
          id: 28,
          question: "舌诊-舌苔：",
          type: "radio",
          answer1: "无舌苔（脾虚）",
          answer1Num: 3,
          answer2: "舌苔黄（体热）",
          answer2Num: 3,
          answer3: "舌苔白（胃寒）",
          answer3Num: 4,
          answer4: "舌苔裂（阴虚）",
          answer4Num: 4,
          answer5: "舌苔厚（身体有积）",
          answer5Num: 4,
          answer6: "舌苔薄白且均匀（平和）",
          answer6Num: 0,
        },
        {
          id: 29,
          question: "舌诊-舌质：",
          type: "radio",
          answer1: "青（寒重，血瘀）",
          answer1Num: 4,
          answer2: "紫（血瘀，中毒）",
          answer2Num: 4,
          answer3: "深红（火大）",
          answer3Num: 3,
          answer4: "淡白（气血双亏）",
          answer4Num: 5,
          answer5: "舌红（内热心火旺）",
          answer5Num: 4,
          answer6: "淡红色（平和）",
          answer6Num: 0,
        },

        {
          id: 30,
          question: "体质评定(最多可以选两个)：",
          type: "checkbox",
          answer1: "白发早生、脱发细软易断、易疲劳、气短懒言、自汗、易感冒",
          answer1Num: 4,
          answer2: "头发干枯分叉、面色苍白、头晕眼花、月经量少色淡、指甲易裂",
          answer2Num: 4,
          answer3:
            "头皮屑多、头发干燥易断、手足心热、失眠多梦、口干舌燥，眼睛干涩，敏感怕热，手脚出汗",
          answer3Num: 4,
          answer4:
            "白发集中于后脑、头发稀疏、畏寒怕冷、夜尿频繁、性欲减退，四肢不温，慢性腹泻，不爱出汗",
          answer4Num: 4,
          answer5:
            "头油分泌旺盛（>1.5mg/cm²）、面部油腻，头皮瘙痒/痤疮、口苦，口臭、大便黏滞",
          answer5Num: 4,
          answer6: "脱发呈弥漫性、体型肥胖、面部多油、胸闷痰多、舌苔厚腻",
          answer6Num: 4,
          answer7:
            "白发集中鬓角、脱发处头皮可见毛细血管扩张、面色晦暗、停经痛经有血块，舌紫暗，大便黑硬，息肉赘瘤",
          answer7Num: 4,
          answer8: "压力性脱发（枕部为主）、焦虑抑郁、胸闷胁痛、失眠，早醒",
          answer8Num: 4,
          answer9: "头皮敏感易红、接触染发剂/洗发水后瘙痒脱屑、过敏性鼻炎史",
          answer9Num: 4,
          answer10: "偶尔烫染，偶见白发，身体无明显不适症状，健谈，舌苔薄白",
          answer10Num: 4,
        },
      ],
    };
  },
  computed: {
    // 计算已回答的题目数量
    answeredCount() {
      return this.questionInfos.filter((item) => item !== undefined).length;
    },
  },
  methods: {
    // 前额第四题
    getSelectedFirstPageNames() {
      const question = this.questionList.find((item) => item.id === 4); // 找到 id 为 1 的问题
      if (!question) return "";

      // 解析 selectedFirstPage 中的选项索引，并获取对应的选项名称
      const selectedNames = this.selectedFirstPage.map((name) => {
        const answerIndex = name.split(",")[2]; // 获取选项索引
        const answers = this.getAnswers(question); // 获取所有选项
        return answers[answerIndex].text; // 获取对应的选项名称
      });

      return selectedNames.join(", "); // 将选项名称拼接成一个字符串
    },
       // 第18题
       get18Names() {
      const question = this.questionList.find((item) => item.id === 18); // 找到 id 为 1 的问题
      if (!question) return "";

      // 解析 selectedFirstPage 中的选项索引，并获取对应的选项名称
      const selectedNames = this.yinshipianhao18.map((name) => {
        const answerIndex = name.split(",")[2]; // 获取选项索引
        const answers = this.getAnswers(question); // 获取所有选项
        return answers[answerIndex].text; // 获取对应的选项名称
      });

      return selectedNames.join(", "); // 将选项名称拼接成一个字符串
    },
        // 第18题
        get19Names() {
      const question = this.questionList.find((item) => item.id === 19); // 找到 id 为 1 的问题
      if (!question) return "";

      // 解析 selectedFirstPage 中的选项索引，并获取对应的选项名称
      const selectedNames = this.bian19.map((name) => {
        const answerIndex = name.split(",")[2]; // 获取选项索引
        const answers = this.getAnswers(question); // 获取所有选项
        return answers[answerIndex].text; // 获取对应的选项名称
      });

      return selectedNames.join(", "); // 将选项名称拼接成一个字符串
    },
    // 获取答案
    getAnswers(item) {
      const answers = [];
      if (item.answer1)
        answers.push({ text: item.answer1, num: item.answer1Num });
      if (item.answer2)
        answers.push({ text: item.answer2, num: item.answer2Num });
      if (item.answer3)
        answers.push({ text: item.answer3, num: item.answer3Num });
      if (item.answer4)
        answers.push({ text: item.answer4, num: item.answer4Num });
      if (item.answer5)
        answers.push({ text: item.answer5, num: item.answer5Num });
      if (item.answer6)
        answers.push({ text: item.answer6, num: item.answer6Num });
      if (item.answer7)
        answers.push({ text: item.answer7, num: item.answer7Num });
      if (item.answer8)
        answers.push({ text: item.answer8, num: item.answer8Num });
      if (item.answer9)
        answers.push({ text: item.answer9, num: item.answer9Num });
      if (item.answer10)
        answers.push({ text: item.answer10, num: item.answer10Num });

      return answers;
    },
    toNext(index, id) {
      this.totalScore = this.questionInfos.reduce((sum, item) => {
        let score = Number(item?.nums || 0);
        return sum + score;
      }, 0);
      console.log("总分:", this.totalScore);
      // 检查当前题目是否已回答
      if (this.questionList[index].type === "radio" && !this.radio) {
        this.$toast("请答题");
        return;
      } else if (
        this.questionList[index].type === "checkbox" &&
        this.selectedFirstPage.length === 0 &&
        id === 4
      ) {
        this.$toast("请答题");
        return;
      } else if (
        this.questionList[index].type === "checkbox" &&
        this.yinshipianhao18.length === 0 &&
        id === 18
      ) {
        this.$toast("请答题");
        return;
      } else if (
        this.questionList[index].type === "checkbox" &&
        this.selectedConstitutions.length === 0 &&
        id === 30
      ) {
        this.$toast("请答题");
        return;
      } else if (
        this.questionList[index].type === "checkbox" &&
        this.bian19.length === 0 &&
        id === 19
      ) {
        this.$toast("请答题");
        return;
      }

      // 保存当前题目的答案
      if (this.questionList[index].type === "radio" && this.radio) {
        const selectedAnswerIndex = this.radio.split(",")[2]; // 获取用户选择的答案索引
        const selectedAnswerText = this.getAnswers(this.questionList[index])[
          selectedAnswerIndex
        ].text; // 获取具体的答案内容
        this.$set(this.questionInfos, index, {
          ids: this.radio.split(",")[1], // 问题id
          nums: this.radio.split(",")[0], // 答案对应的分值
          answerText: selectedAnswerText, // 具体的答案内容
          question: this.questionList[index].question, // 问题的标题
        });
      } else if (this.questionList[index].type === "checkbox" && id === 4) {
        // 第一页的复选框逻辑
        this.$set(this.questionInfos, index, {
          ids: this.questionList[index].id, // 问题id
          nums: this.selectedFirstPage.length * 2, // 每个选项加2分
          answerText: this.selectedFirstPage
            .map((name) => {
              const answerIndex = name.split(",")[2];
              return this.getAnswers(this.questionList[index])[answerIndex]
                .text;
            })
            .join(", "), // 具体的答案内容
          question: this.questionList[index].question, // 问题的标题
        });
      } else if (this.questionList[index].type === "checkbox" && id === 30) {
        // 体质评定的复选框逻辑
        this.$set(this.questionInfos, index, {
          ids: this.questionList[index].id, // 问题id
          nums: this.selectedConstitutions.length * 4, // 每个选项加4分
          answerText: this.selectedConstitutions
            .map((name) => {
              const answerIndex = name.split(",")[2];
              return this.getAnswers(this.questionList[index])[answerIndex]
                .text;
            })
            .join(", "), // 具体的答案内容
          question: this.questionList[index].question, // 问题的标题
        });
      } else if (this.questionList[index].type === "checkbox" && id === 18) {
        // 第一页的复选框逻辑
        this.$set(this.questionInfos, index, {
          ids: this.questionList[index].id, // 问题id
          nums: this.yinshipianhao18.length * 2, // 每个选项加2分
          answerText: this.yinshipianhao18
            .map((name) => {
              const answerIndex = name.split(",")[2];
              return this.getAnswers(this.questionList[index])[answerIndex]
                .text;
            })
            .join(", "), // 具体的答案内容
          question: this.questionList[index].question, // 问题的标题
        });
      }else if (this.questionList[index].type === "checkbox" && id === 19) {
        // 第一页的复选框逻辑
        this.$set(this.questionInfos, index, {
          ids: this.questionList[index].id, // 问题id
          nums: this.bian19.length * 2, // 每个选项加2分
          answerText: this.bian19
            .map((name) => {
              const answerIndex = name.split(",")[2];
              return this.getAnswers(this.questionList[index])[answerIndex]
                .text;
            })
            .join(", "), // 具体的答案内容
          question: this.questionList[index].question, // 问题的标题
        });
      }

      // 计算总分
      this.totalScore = this.questionInfos.reduce((sum, item) => {
        let score = Number(item?.nums || 0);
        return sum + score;
      }, 0);

      // 清空并跳转
      index++;
      if (index < this.questionList.length) {
        const nextQuestion = this.questionInfos[index];
        if (nextQuestion && this.questionList[index].type === "radio") {
          // 恢复下一题的 radio 值
          const answerIndex = this.getAnswers(
            this.questionList[index]
          ).findIndex((answer) => answer.text === nextQuestion.answerText);
          if (answerIndex !== -1) {
            this.radio =
              this.getAnswers(this.questionList[index])[answerIndex].num +
              "," +
              this.questionList[index].id +
              "," +
              answerIndex;
          }
        } else {
          this.radio = "";
        }
        this.page = index;
      }
      this.updateIsShow();
    },
    toBack(index) {
      index--;
      const prevQuestion = this.questionInfos[index];
      if (prevQuestion) {
        // 根据之前保存的答案恢复 radio 的值
        const answerIndex = this.getAnswers(this.questionList[index]).findIndex(
          (answer) => answer.text === prevQuestion.answerText
        );
        if (answerIndex !== -1) {
          this.radio =
            this.getAnswers(this.questionList[index])[answerIndex].num +
            "," +
            this.questionList[index].id +
            "," +
            answerIndex;
        }
      } else {
        this.radio = "";
      }
      this.page = index;
      this.updateIsShow();
    },
    updateIsShow() {
      this.isShow = this.page < this.questionList.length - 1;
    },
    submit() {

      console.log(this.questionList[29].type);  
      if (
        this.questionList[29].type === "checkbox" &&
        this.selectedConstitutions.length === 0
      ) {
        this.$toast("请答题");
        return;
      }
      //最后要传递
      //前额
      const ti4 = this.getSelectedFirstPageNames();
      console.log("4用户选择的选项名称:", ti4);

      const ti18 = this.get18Names();
      console.log("18用户选择的18选项名称:", ti18);

      const ti19 = this.get19Names();
      console.log("19用户选择的选项名称:", ti19);
      // 计算总分
      this.totalScore = this.questionInfos.reduce((sum, item) => {
        let score = Number(item?.nums || 0);
        return sum + score;
      }, 0);
      // 添加体质评定的得分
      if (this.selectedConstitutions.length === 1) {
        this.totalScore += 4; // 勾选一个加2分
      } else if (this.selectedConstitutions.length === 2) {
        this.totalScore += 8; // 勾选两个加4分
      }
      // 获取白发等级信息
      this.hairGradeInfo = this.getHairGradeInfo(this.totalScore);

      this.selectedQuestions = [8,9,10,11,12,13,14,15,16,17,21,22,23,24,25,26,27,28].map(index => {
    const questionInfo = this.questionInfos[index];
    return {
      id: this.questionList[index].id, // 问题id
      question: this.questionList[index].question, // 问题标题
      answer: questionInfo?.answerText || '' // 用户选择的答案内容
    };
  });

      // 显示弹窗
      this.showDialog = true;
      setTimeout(() => {
        console.log("zongfen", this.totalScore);
        this.isGenerating = false;

        this.$router.push({
          name: "ResultPage",
          params: {
            savedAnswers: this.selectedQuestions,
            selectedConstitutionsCount: this.selectedConstitutions.length,
            selectedConstitutions: this.selectedConstitutions, // 传递选中的体质测评选项
            hairGradeInfo: this.hairGradeInfo,
            ti4: this.getSelectedFirstPageNames(),
            ti18: this.get18Names(),
            ti19: this.get19Names(),
          },
        });
      }, 3000);
    },
    getHairGradeInfo(totalScore) {
      if (totalScore <= 49) {
        return "2级白发-调理周期约2个月16次";
      } else if (totalScore <= 63) {
        return "3级白发调理周期约3个月24次";
      } else if (totalScore <= 77) {
        return "4级白发调理周期约6个月48次";
      } else if (totalScore <= 98) {
        return "5级白发调理周期约9个月108次";
      } else if (totalScore <= 112) {
        return "6级白发调理周期约12个月144次";
      } else {
        return "7级白发调理周期约24个月360次以上";
      }
    },
  },
};
</script>

<style>
.second {
  background-color: #f7f7f7;
}

.test-content {
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  margin-bottom: 10px;
}

.content-title {
  color: #fb7e22;

  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.radio {
  margin-left: 10px;
  height: 50px !important;
}

.btn {
  display: flex;
  justify-content: space-between;
}

.back,
.next {
  font: 400;
  color: #fb7e22;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.radio {
  height: 30px;
}

.dialog-content {
  padding: 20px;
  text-align: center;
  font-size: 18px;
}
/* 标题 */
/* 使用CSS渐变背景 */

.custom-nav-bar {
  text-align: center;
  width: 100%;
  align-content: center;
  height: 45px;
  background-color: #fb7e22;
  color: white;
}

.van-radio__icon--checked .van-icon {
  color: #fff;
  background-color: #fb7e22 !important;
  border-color: #fb7e22 !important;
}
/* radio字体 */
.van-radio__label {
  /* color: #fb7e22; */
  font-size: 16px;
  size: 18px;
  margin-left: 8px;
  /* color: #323233; */
  line-height: 20px;
}
.van-checkbox__icon--checked .van-icon {
  color: #fff;
  background-color: #fb7e22 !important;
  border-color: #fb7e22 !important;
}
.van-checkbox {
  height: 50px !important;
}
.checkbox30{
  height: 60px !important;
}

.van-checkbox__label {
  font-size: 16px;
  margin-left: 8px;
  line-height: 20px;
}
/* 总题数 已经答题 */
.progress-container {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
}

.progress-info {
  padding: 8px 15px;
  border-radius: 15px;
  font-size: 14px;
  color: #fb7e22;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>